import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-support",
  templateUrl: "./support.component.html",
})
export class SupportComponent implements OnInit {
  public currentLanguageCode: string;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.currentLanguageCode = this.translate.getBrowserLang();
  }
}
